
/**
 * Компонент карточек фильтров на странице каталога над красной плашкой
 */
import type { PhotoFilter } from '~/type/PhotoFilter';
interface Props {
  el: PhotoFilter;
  value?: PhotoFilter;
  photoLazyload: boolean;
}
const __sfc_main = {};
__sfc_main.props = {
  el: {
    key: "el",
    required: true,
    type: null
  },
  value: {
    key: "value",
    required: false,
    type: null
  },
  photoLazyload: {
    key: "photoLazyload",
    required: false,
    type: Boolean,
    default: true
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const props = __props;
  const emit = __ctx.emit;
  function onClick(el: PhotoFilter) {
    if (el !== props.value) {
      /**
      * Срабатывавает при нажатии на фильтр
      */
      emit('change', el);
    }
  }
  return {
    onClick
  };
};
export default __sfc_main;
